import firebase from 'firebase/app'
import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'
import { Loading } from 'element-ui'

export default {
  state: {
    UserCardList: [],
    UserCardLasted: [],
    UserCardDetail: null,
    DeleteCard: false
  },
  mutations: {
    setUserCardList (state, payload) {
      state.UserCardList = payload
    },
    setUserCardDetail (state, payload) {
      state.UserCardDetail = payload
    },
    setUserCardLasted (state, payload) {
      state.UserCardLasted = payload
    },
    setDeleteCard (state, payload) {
      state.DeleteCard = payload
    }
  },
  actions: {
    getUserCardList ({commit, dispatch}, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          let branchUUID = JSON.parse(localStorage.getItem('branch')).uuid
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'branches/'+ branchUUID +'/users/credit-cards',
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              // dispatch('getUserCardDetail', response.data.data[0].uid)
              commit('setUserCardList', response.data.data)
              commit('setUserCardLasted', response.data.data[0])
            } else {
              commit('setUserCardList', [])
            }
          })
        })
      })
    },
    getUserCardDetail ({commit}, uid) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'users/credit-cards/' + uid,
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              commit('setUserCardDetail', response.data.data)
            } else {
              commit('setUserCardDetail', [])
            }
          })
        })
      })
    },
    deleteCreditCard ({commit}, uid) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          axios({
            method: 'DELETE',
            url: API_MASTER_DATA + 'users/credit-cards/' + uid,
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              let loadinginstance = Loading.service({ fullscreen: true, lock: true })
              loadinginstance.close()
              commit('setDeleteCard', true)
            } else {
              commit('setDeleteCard', false)
            }
          })
        })
      })
    }
  },
  getters: {
    UserCardList (state) {
      return state.UserCardList
    },
    UserCardLasted (state) {
      return state.UserCardLasted
    },
    UserCardDetail (state) {
      return state.UserCardDetail
    },
    DeleteCard (state) {
      return state.DeleteCard
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/card/index.js